import React from "react";
import { Row, Col, Spin, Alert } from "antd";
import ContinueButton from "../../../assets/AntDesign/Buttons/ContinueButton";
import InputField from "../../../assets/AntDesign/Inputs/InputField";
import chooseImage from "../../../assets/icons/tswira.png";
import icon1 from "../../../assets/images/logomedilink.svg";
import "./EmailCode.css"; // ✅ tu peux réutiliser le même CSS

import { useDoctorEmailCode } from "../../hooks/useDoctorEmailCode";

export default function EmailCode() {
  const { email, handleChange, handleSendCode, isValid, loading, error, message } =
    useDoctorEmailCode();

  return (
    <div className="ecode-container">
      <Row className="ecode-row" gutter={0}>
        {/* ===== LEFT PANEL ===== */}
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={10}
          xl={10}
          className="ecode-left"
          style={{ backgroundImage: `url(${chooseImage})` }}
        >
          <div className="ecode-overlay" />
          <div className="ecode-hero-top-icon" aria-hidden="true">
            <img src={icon1} alt="decorative icon" />
          </div>

          <div className="ecode-hero">
            <h3>
              FORGOT YOUR PASSWORD?
              <br />
              NO WORRIES.
            </h3>
            <p>
              Enter your email below and we’ll send you a
              <br />
              <strong>SECURE RESET CODE.</strong>
            </p>
          </div>
        </Col>

        {/* ===== RIGHT PANEL ===== */}
        <Col xs={24} sm={24} md={24} lg={14} xl={14} className="ecode-right">
          <div className="ecode-panel">
            <h1 className="ecode-title">Password Forgot?</h1>
            <p className="ecode-subtitle">
              Please enter your email to receive a reset code.
            </p>

            {loading && (
              <div className="ecode-loader">
                <Spin tip="Sending..." />
              </div>
            )}

            {error && <Alert className="ecode-alert" type="error" message={error} showIcon />}
            {message && (
              <Alert className="ecode-alert-success" type="success" message={message} showIcon />
            )}

            <div className="ecode-form">
              <InputField
                label="Email Address"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => handleChange(e.target.value)}
                error={error}
              />

              <div className="ecode-button-container">
                <ContinueButton disabled={!isValid || loading} onClick={handleSendCode}>
                  {loading ? "Sending..." : "Send Code"}
                </ContinueButton>
              </div>
            </div>

          </div>
        </Col>
      </Row>
    </div>
  );
}
